import { hsMakeDefaultLights } from '../functions/make-default-lights.function';
import type { HsLight } from '../objects/lights/light.class';

export class HsLightStorage {
  public static readonly default: HsLightStorage = new HsLightStorage(hsMakeDefaultLights());

  constructor(public readonly lights: HsLight[] = []) {}
}
